var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tenant-breadcrumb-bar',{attrs:{"back-label":_vm.$t('nav.historyback'),"items":_vm.items},on:{"back":_vm.back,"select":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }